import { gql } from '@lcs/shared/api';

export const deleteBlockedPhoneNumberMutation = gql`
   mutation DeleteBlockedPhoneNumber($blockedPhoneNumberId: UInt!) {
      deleteBlockedPhoneNumber(id: $blockedPhoneNumberId)
   }
`;
